import Link from 'next/link'
import PropTypes from 'prop-types'

// import { CartDiscountCodesUpdateMutation } from 'gql/cart'
import { formatMoney, isBlank, isPresent } from 'utils'

// import { useMutation } from 'urql'
// import { parseCookies } from 'nookies'
import Button from 'components/Button'
import Spacer from 'components/Spacer'
import Text from 'components/Text'

import { Root, Table } from './CartSummary.style'

const CartSummary = ({ cart }) => {
  // const { cartId } = parseCookies()
  // const [_cartDiscountCodesUpateResult, cartDiscountCodesUpate] = useMutation(CartDiscountCodesUpdateMutation)

  // const applyDiscountCode = async () => {
  //   const result = await cartDiscountCodesUpate({ cartId, discountCodes: ['BIRCH-PERCENT'] })
  // }

  if (isBlank(cart)) return null

  const lines = cart?.lines?.edges?.map((edge) => edge.node) || []

  const totalDiscount = lines.reduce((acc, line) => {
    const discountsTotal = line.discountAllocations.reduce(
      (acc, { discountedAmount: { amount } }) => acc + Number(amount),
      0
    )
    return acc + discountsTotal
  }, 0)

  return (
    <Root>
      <Table>
        {/* <thead>
          <th colSpan={2}>
            <SubHeader>Total</SubHeader>
          </th>
        </thead> */}
        <tbody>
          <tr>
            <td>
              <Text>Subtotal</Text>
            </td>
            <td>
              <Text>{formatMoney(cart.estimatedCost.subtotalAmount?.amount, { fractional: false })}</Text>
            </td>
          </tr>
          {isPresent(totalDiscount) && totalDiscount > 0 && (
            <tr>
              <td>
                <Text weight="bold">Discount</Text>
                {/* {cart.discountCodes.map(({ code }, index) => (
                <Text key={index} weight="bold">
                  {code}
                </Text>
              ))} */}
              </td>
              <td>
                <Text weight="bold">- {formatMoney(totalDiscount, { fractional: false })}</Text>
              </td>
            </tr>
          )}
          <tr>
            <td>
              <Text>Taxes</Text>
            </td>
            <td>
              <Text>{formatMoney(cart.estimatedCost.totalTaxAmount?.amount, { fractional: false })}</Text>
            </td>
          </tr>
          <tr>
            <td>
              <p>
                <Text>Shipping</Text>
              </p>
            </td>
            <td>
              <Text size="xs">Calculated at checkout</Text>
            </td>
          </tr>
          <tr>
            <td>
              <Text>Total</Text>
            </td>
            <td>
              <Text font="stint" size="lg">
                {formatMoney(cart.estimatedCost.totalAmount?.amount, { fractional: false })}
              </Text>
            </td>
          </tr>
        </tbody>
      </Table>
      <Link href={cart.checkoutUrl} passHref legacyBehavior>
        <Button text="Checkout" width="full" as="a" />
      </Link>
      <Spacer y={4} />
      <Link href="/" passHref legacyBehavior>
        <Button text="Continue shopping" variant="outlined" width="full" />
      </Link>
      {/* <br />
      <Button text="Apply discount" onClick={applyDiscountCode} /> */}
    </Root>
  )
}

CartSummary.propTypes = {
  cart: PropTypes.shape({
    estimatedCost: PropTypes.shape({
      subtotalAmount: PropTypes.shape({
        amount: PropTypes.number,
      }),
      totalTaxAmount: PropTypes.shape({
        amount: PropTypes.number,
      }),
      totalAmount: PropTypes.shape({
        amount: PropTypes.number,
      }),
    }),
    lines: PropTypes.shape({
      edges: PropTypes.arrayOf(
        PropTypes.shape({
          node: PropTypes.shape({
            discountAllocations: PropTypes.arrayOf(
              PropTypes.shape({
                discountedAmount: PropTypes.shape({
                  amount: PropTypes.number,
                }),
              })
            ),
          }),
        })
      ),
    }),
  }),
}

CartSummary.defaultProps = {}

export default CartSummary
